// Catálogos de tradução. PT-BR é o padrão e o fallback: toda chave criada
// precisa existir em PT-BR; o par em EN é obrigatório para não regredir o idioma.
// Chaves planas, com namespace por ponto.
export const LOCALES = {
  en: {
    // Comuns
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.create": "Create",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.details": "Details",
    "common.confirm": "Confirm",
    "dialog.typeToConfirm": "Type {text} to confirm.",
    "common.loading": "Loading…",
    "common.language": "Language",
    "common.firstName": "First name",
    "common.lastName": "Last name",
    "common.phone": "Mobile phone",
    "common.email": "E-mail",
    "common.country": "Country",
    "common.countryPlaceholder": "US",
    "common.state": "State",
    "common.city": "City",
    "common.actions": "Actions",
    "common.createdAt": "Created at",
    "common.updatedAt": "Updated at",
    "common.none": "None",
    "common.yes": "Yes",
    "common.no": "No",
    "common.saveError": "Failed to save.",
    "common.loadError": "Failed to load.",
    "common.deleteError": "Failed to delete. Please try again.",
    "common.copy": "Copy",
    "common.copied": "Copied!",
    "common.done": "Done",
    "common.close": "Close",
    "common.retry": "Try again",

    // Navegação / layout
    "nav.dashboard": "Dashboard",
    "nav.events": "Events",
    "nav.championships": "Championships",
    "nav.sports": "Sports",
    "nav.sportCategories": "Categories",
    "nav.admin": "Admin",
    "nav.accounts": "Users",
    "nav.settings": "Settings",
    "nav.logout": "Sign out",
    "nav.backToSite": "Back to the site",

    // Dashboard
    "dashboard.title": "Dashboard",
    "dashboard.welcome": "Welcome to {brand}",
    "dashboard.subtitle": "Pick an option on the side menu to start.",

    // Login
    "login.title": "Sign in",
    "login.email": "E-mail",
    "login.password": "Password",
    "login.continue": "Continue",
    "login.office365": "Sign in with Office 365",
    "login.secface": "Sign in with SecFace",
    "login.sso": "Sign in with SSO",
    "login.contactHint": "If you do not remember your registered e-mail, contact us at",
    "login.mfaTitle": "Two-factor code",
    "login.wrongPassword": "Incorrect password. Please try again.",
    "login.headline": "Sign in",
    "login.subtitle": "Enter the e-mail registered in the system.",
    "login.emailPlaceholder": "you@example.com",
    "login.validateCode": "Validate code",
    "login.codeNotReceived": "Did not receive the code?",
    "login.mfaSubtitle": "Enter the 6-digit code from your authenticator app.",
    "login.passwordPlaceholder": "Enter your password",
    "login.passwordSubtitle": "Enter your account password to continue.",
    "login.signIn": "Sign in",
    "login.changePassword": "Change password",
    "login.changePasswordSubtitle": "Your password must be changed before you continue.",
    "login.newPassword": "New password",
    "login.newPasswordPlaceholder": "Enter the new password",
    "login.confirmPassword": "Confirm new password",
    "login.confirmPasswordPlaceholder": "Confirm the new password",
    "login.check.minLength": "At least 8 characters",
    "login.check.uppercase": "Uppercase letter",
    "login.check.lowercase": "Lowercase letter",
    "login.check.special": "Special character",
    "login.check.match": "Passwords match",
    "login.passwordMismatch": "Passwords do not match.",
    "login.changePasswordError": "Failed to change the password.",
    "login.invalidCode": "Invalid code. Please try again.",
    "login.or": "or",
    "login.resend": "Resend",
    "login.incompleteCode": "Enter the complete 6-digit code.",
    "login.adminOnlyTitle": "Administrators only",
    "login.adminOnlyHint":
      "You do not need an account to see or download your photos — just open the event on the public site.",
    "login.goToPublic": "Go to the photo site",
    "login.configErrorTitle": "Service unavailable",
    "login.configErrorHint": "Could not load the sign-in configuration. Please try again in a moment.",
    "login.configRetry": "Try again",
    "sso.finishing": "Finishing sign-in…",
    "sso.failed": "Sign-in failed",
    "sso.wait": "Please wait, validating the SSO authentication.",
    "sso.backToLogin": "Back to sign-in",
    "sso.error": "Failed to complete the SSO sign-in.",


    // Contas / permissões
    "account.title": "Users",
    "account.subtitle": "Manage the users and their permission levels.",
    "account.new": "New user",
    "account.edit": "Edit user",
    "account.newSubtitle": "The user receives the initial password and the MFA QR Code by e-mail.",
    "account.empty": "No users registered.",
    "account.role": "Permission level",
    "account.role.user": "User",
    "account.role.operator": "Operator",
    "account.role.admin": "Admin",
    "account.roleHint": "Least privilege: Operator manages events and photos; Admin also manages users and settings.",
    "account.language": "Language",
    "account.languageDefault": "System default",
    "account.policyLabel": "Password policy",
    "account.mustChange": "Require password change on next sign-in",
    "account.cannotChange": "Do not allow this user to change the password",
    "account.policyExclusive": "The two options are mutually exclusive.",
    "account.mfaTitle": "Two-factor authentication (MFA)",
    "account.mfaHint":
      "Scan the QR Code in an authenticator app (Google Authenticator, Authy…) or type the secret manually.",
    "account.resetMfa": "Reset MFA",
    "account.resetMfaTitle": "Reset this user's MFA?",
    "account.resetMfaBody":
      "A new secret is generated and the previously configured authenticator stops working immediately.",
    "account.resetMfaDone": "MFA reset",
    "account.resetMfaDoneBody": "Send the new QR Code to the user so they can enroll again.",
    "account.resetMfaError": "Failed to reset the MFA.",
    "account.deleteTitle": "Remove user?",
    "account.deleteBody": "Are you sure you want to remove {name}?",
    "account.registered": "User registered",
    "account.credentialsSent": "The password and the MFA QR Code were sent by e-mail to the user.",
    "account.initialPassword": "Initial password",
    "account.detailsTitle": "User details",
    "account.notFound": "User not found.",
    "account.status": "Status",
    "account.active": "Active",
    "account.inactive": "Inactive",

    // Configurações / política de senha
    "settings.title": "General settings",
    "settings.subtitle": "Configure the system-wide parameters",
    "settings.save": "Save settings",
    "settings.saving": "Saving…",
    "settings.saved": "Settings saved successfully.",
    "settings.saveError": "Failed to save settings.",
    "policy.title": "Password policy",
    "policy.subtitle": "Configure the minimum password requirements for all users",
    "policy.minLength": "Minimum length",
    "policy.minLengthHint": "Minimum number of characters (8-40).",
    "policy.requireUppercase": "Require uppercase letter",
    "policy.requireUppercaseHint": "The password must contain at least one uppercase letter (A-Z).",
    "policy.requireLowercase": "Require lowercase letter",
    "policy.requireLowercaseHint": "The password must contain at least one lowercase letter (a-z).",
    "policy.requireSpecial": "Require special character",
    "policy.requireSpecialHint": "The password must contain at least one special character (!@#$%…).",
    "policy.blacklist": "Blocked words",
    "policy.blacklistHint": "Words that cannot appear in the password (case-insensitive).",
    "policy.blacklistEmpty": "No blocked words.",
    "policy.add": "Add",
    "policy.save": "Save policy",
    "policy.saved": "Password policy saved successfully.",
    "policy.saveError": "Failed to save the password policy.",
    "policy.tabData": "Data",
    "policy.tabPolicy": "Password policy",

    // Campeonatos (painel)
    "championship.title": "Championships",
    "championship.subtitle": "Competitions that group the events (their stages).",
    "championship.new": "New championship",
    "championship.edit": "Edit championship",
    "championship.newSubtitle": "Fill in the data to register a new championship.",
    "championship.editSubtitle": "Change this championship's data.",
    "championship.empty": "No championships registered.",
    "championship.notFound": "Championship not found.",
    "championship.name": "Championship name",
    "championship.namePlaceholder": "Summer Cup",
    "championship.description": "Description",
    "championship.season": "Season",
    "championship.seasonPlaceholder": "2026",
    "championship.seasonHint": "The edition that tells one year apart from another (2026, 2025/26).",
    "championship.organizer": "Organizer",
    "championship.organizerPlaceholder": "Southern League",
    "championship.events": "Events",
    "championship.eventsCount": "{count} event(s)",
    "championship.noEvents": "No events linked to this championship yet.",
    "championship.publicUrl": "Public address",
    "championship.searchPlaceholder": "Search by championship name",
    "championship.deleteTitle": "Delete championship?",
    "championship.deleteBody": "Are you sure you want to delete {name}? The events are kept, only without the championship.",

    // Eventos (painel)
    "event.title": "Events",
    "event.subtitle": "Manage the events and their photo collections.",
    "event.new": "New event",
    "event.edit": "Edit event",
    "event.duplicate": "Duplicate",
    "event.duplicateTitle": "Duplicate event",
    "event.duplicateSubtitle":
      "Data copied from “{name}”. Photos and cover are not copied — " +
      "choose a new name and save to create the event.",
    "event.newSubtitle": "Fill in the data to register a new event.",
    "event.editSubtitle": "Change this event's data and settings.",
    "event.empty": "No events registered.",
    "event.notFound": "Event not found.",
    "event.name": "Event name",
    "event.namePlaceholder": "Regional Basketball Tournament",
    "event.description": "Description",
    "event.dates": "Dates",
    "event.startDate": "Start date",
    "event.endDate": "End date",
    "event.category": "Event type",
    "event.sport": "Sport",
    "event.sportPlaceholder": "Select the sport",
    "event.sportCategory": "Category",
    "event.noSportCategory": "No category",
    "event.sportCategoryHint": "The category chip appears in the corner of the event card on the public site. Categories are managed in the Categories menu.",
    "sport.title": "Sports",
    "sport.subtitle": "Sports offered when creating an event.",
    "sport.new": "New sport",
    "sport.newSubtitle": "Add a sport to the list.",
    "sport.edit": "Edit sport",
    "sport.editSubtitle": "Rename the sport. Events that use it follow the new name.",
    "sport.name": "Name",
    "sport.namePlaceholder": "E.g.: Basketball",
    "sport.searchPlaceholder": "Search by sport name",
    "sport.empty": "No sports registered.",
    "sport.categories": "Categories",
    "sport.events": "Events",
    "sport.viewCategories": "Categories of this sport",
    "sport.deleteTitle": "Delete sport?",
    "sport.deleteBody": "Delete {name}? Events that already use it keep showing it, but it can no longer be chosen.",
    "sportCategory.title": "Categories",
    "sportCategory.subtitle": "Categories of each sport and the colors of the chip shown on the event card.",
    "sportCategory.new": "New category",
    "sportCategory.newSubtitle": "Create a category and choose the chip colors.",
    "sportCategory.edit": "Edit category",
    "sportCategory.editSubtitle": "Change the name or the chip colors.",
    "sportCategory.name": "Name",
    "sportCategory.namePlaceholder": "E.g.: U15 Men",
    "sportCategory.searchPlaceholder": "Search by category name",
    "sportCategory.allSports": "All sports",
    "sportCategory.empty": "No categories registered.",
    "sportCategory.chip": "Chip",
    "sportCategory.colors": "Chip colors",
    "sportCategory.backgroundColor": "Background color",
    "sportCategory.textColor": "Text color",
    "sportCategory.preview": "Preview",
    "sportCategory.customColors": "Custom colors — no preset matches.",
    "sportCategory.deleteTitle": "Delete category?",
    "sportCategory.deleteBody": "Delete {name}? Events that use it stop showing the chip.",
    "chipPreset.male": "Men",
    "chipPreset.female": "Women",
    "chipPreset.mixed": "Mixed",
    "chipPreset.neutral": "Neutral",
    "chipPreset.youth": "Youth",
    "chipPreset.adult": "Adult",
    "chipPreset.master": "Masters",
    "chipPreset.highlight": "Highlight",
    "chipPreset.maleStrong": "Men (strong)",
    "chipPreset.femaleStrong": "Women (strong)",
    "chipPreset.dark": "Dark",
    "chipPreset.light": "Light",
    "event.championship": "Championship",
    "event.noChampionship": "No championship (standalone event)",
    "event.championshipHint": "Link the event to a competition so it shows up on the championship page.",
    "event.locationSection": "Location",
    "event.locationName": "Venue",
    "event.locationPlaceholder": "Municipal Gymnasium",
    "event.address": "Address",
    "event.place": "Place",
    "event.photos": "Photos",
    "event.pending": "Being processed",
    "event.people": "People",
    "event.status": "Status",
    "event.statusHint": "Published: listed on the public site. Unlisted: hidden from listings and search, but anyone with the link sees the photos. Draft and Archived are not public.",
    "event.watermark": "Add watermark",
    "event.features": "Features",
    "event.feature.watermark": "Watermarked photos",
    "event.watermarkHint": "Every photo of the event gets the site watermark in the bottom-right corner. Changing it on an event that already has photos updates them in the background, a few at a time.",
    "event.allStatuses": "All statuses",
    "event.searchPlaceholder": "Search by event name",
    "event.deleteTitle": "Delete event?",
    "event.deleteBody": "Are you sure you want to delete {name}? The photos stop being published.",
    "event.viewPublic": "View public page",
    "event.coverTitle": "Event cover",
    "event.coverSubtitle": "The image that represents the event on the public site.",
    "event.coverUpload": "Upload an image",
    "event.coverRemove": "Remove cover",
    "event.coverHint":
      "Click or drag an image here. Without a cover, the first processed photo is used automatically. You can also pick any photo below with the image button.",
    "event.coverError": "Could not change the cover.",
    "event.coverDropHere": "Drop the image here to use it as the cover",
    "event.coverDropInvalid": "The dropped file is not an image.",
    "event.coverRemoveTitle": "Remove the cover?",
    "event.coverRemoveBody":
      "The event goes back to using the first processed photo as its cover.",
    "event.setAsCover": "Set as cover",
    "event.pendingCount": "{count} in the queue",
    "event.peopleEmpty": "No faces grouped yet.",
    "event.personPhotos": "{count} photos",
    "event.status.draft": "Draft",
    "event.status.published": "Published",
    "event.status.unlisted": "Unlisted",
    "event.status.archived": "Archived",
    "event.tab.photos": "Photos",
    "event.tab.people": "People",
    "event.category.sports": "Sports",
    "event.category.corporate": "Corporate",
    "event.category.party": "Party",
    "event.category.wedding": "Wedding",
    "event.category.graduation": "Graduation",
    "event.category.concert": "Concert",
    "event.category.other": "Other",

    // Fotos (upload e processamento)
    "photo.uploadTitle": "Upload photos",
    "photo.uploadSubtitle":
      "The files are uploaded one by one. Processing (JPEG 1080p and face detection) runs in the background right after.",
    "photo.dropTitle": "Drag the photos here or click to choose",
    "photo.dropHint": "JPEG, PNG, WEBP, HEIC or TIFF up to 40 MB each.",
    "photo.queueSummary": "{done} of {total} ready",
    "photo.queueUploaded": "{count} of {total} uploaded",
    "photo.queueBusy": "{count} in progress",
    "photo.clearFinished": "Clear finished",
    "photo.facesFound": "{count} faces",
    "photo.uploadError": "Upload failed.",
    "photo.empty": "No photos in this event yet.",
    "photo.clear": "Clear photos",
    "photo.clearTitle": "Delete all photos?",
    "photo.clearBody": "All {count} photos of this event will be permanently deleted, along with the recognized faces and people. This cannot be undone.",
    "photo.clearConfirm": "Delete all",
    "photo.clearWord": "delete",
    "photo.deleteTitle": "Delete photo?",
    "photo.deleteBody":
      "The photo file and the biometrics extracted from it are permanently deleted. This cannot be undone.",
    "photo.reprocess": "Process again",
    "photo.reprocessError": "Could not queue the photo again.",
    "photo.faceUnavailable": "Processed without face recognition.",
    "photo.status.queued": "In queue",
    "photo.status.uploading": "Uploading",
    "photo.status.processing": "Processing",
    "photo.status.done": "Ready",
    "photo.status.failed": "Failed",
    "photo.replaced": "updated",
    "photo.merged": "the event already had this image — the most complete copy was kept",

    // Area publica
    "public.nav.events": "Events",
    "public.nav.photoEditor": "Photo editor",
    "public.nav.signIn": "Sign in",
    "public.home.headline": "Find your photos from the event",
    "public.home.subtitle":
      "Browse the covered events and use your selfie to find every photo you appear in.",
    "public.home.searchPlaceholder": "Search by event, venue or city",
    "public.home.allCategories": "All types",
    "public.home.allCities": "All cities",
    "public.home.allChampionships": "All championships",
    "public.home.when": "Period",
    "public.home.when.all": "Any date",
    "public.home.when.active": "Happening now",
    "public.home.when.upcoming": "Upcoming",
    "public.home.when.past": "Past",
    "public.home.eventsTitle": "Events",
    "public.home.empty": "No events found",
    "public.home.emptyHint": "Try another search term or clear the filters.",
    "public.home.loadErrorHint": "Could not load the events. Please try again.",
    "public.championship.eventsTitle": "Events in this championship",
    "public.championship.eventsCount": "{count} event(s)",
    "public.championship.empty": "No events published yet",
    "public.championship.notFoundHint": "This championship has no published event, or the address is wrong.",
    "public.championship.backHome": "Back to events",

    "public.event.photos": "photos",
    "public.event.notFound": "Event not found",
    "public.event.backToEvents": "Back to events",
    "public.event.allPhotos": "All photos",
    "public.event.noPhotos": "No photos published yet",
    "public.event.noPhotosHint": "The photos appear here as soon as they are processed.",
    "public.event.previous": "Previous",
    "public.event.next": "Next",
    "public.event.loadingMore": "Loading more photos…",
    "public.event.endOfAlbum": "You reached the end of the album.",
    "public.search.title": "Find your photos",
    "public.search.hint":
      "Send a selfie and we will look for your face in this event's photos. The selfie is used only for the comparison and is not stored.",
    "public.search.action": "Send a selfie",
    "public.search.showAll": "Show all photos",
    "public.search.error": "Could not run the search. Please try again.",
    "public.search.resultsTitle": "Your photos",
    "public.search.noResults": "No photo found",
    "public.search.noResultsHint":
      "Try another selfie, taken from the front and well lit.",
    "public.search.copyLink": "Copy search link",
    "public.search.sharedNotFound": "This search is no longer available.",
    "public.search.openEvent": "Open event",
    "public.home.selfieTitle": "Find your photos in every event",
    "public.home.selfieHint":
      "Send a selfie and we will look for your face in the photos of the events matching the filters above. The selfie is used only for the comparison and is not stored.",
    "public.home.showEvents": "Show events",
    "public.selfie.title": "Search your photos with a selfie",
    "public.selfie.drag": "Drag an image here or",
    "public.selfie.upload": "upload a file",
    "public.selfie.or": "or",
    "public.selfie.paste": "Paste image",
    "public.selfie.pasteHint": "You can also press Ctrl+V (⌘+V on Mac).",
    "public.selfie.searching": "Looking for your face in the photos…",
    "public.selfie.notImage": "The selected file is not an image.",
    "public.selfie.clipboardEmpty": "There is no image in the clipboard.",
    "public.selfie.clipboardDenied":
      "Could not read the clipboard. Press Ctrl+V (⌘+V on Mac) to paste the image.",
    "public.selfie.privacy":
      "The selfie is used only for the comparison and is not stored.",
    "public.photo.notFound": "Photo not found",
    "public.photo.backToEvent": "Back to the event",
    "public.photo.download": "Download",
    "public.photo.share": "Share",
    "public.footer.aboutTitle": "Made by a dad, for the sport. 🏀📸",
    "public.footer.aboutP1":
      "I am an athlete's father and I created Photoe out of a passion for sport and for photography.",
    "public.footer.aboutP2":
      "This project is not-for-profit. Its purpose is to record and share moments from the games, championships and events of the teams my son takes part in, no matter the club, school or team he is representing.",
    "public.footer.aboutP3":
      "Photographs are a way to preserve stories, to celebrate the athletes and to let families, friends and teams keep a little of every moment lived on and off the court.",

    // Erros
    "error.accessDenied": "Access denied.",
    "error.generic": "Something went wrong. Please try again.",
  },

  "pt-br": {
    "common.back": "Voltar",
    "common.cancel": "Cancelar",
    "common.save": "Salvar",
    "common.create": "Criar",
    "common.edit": "Editar",
    "common.delete": "Excluir",
    "common.details": "Detalhes",
    "common.confirm": "Confirmar",
    "dialog.typeToConfirm": "Digite {text} para confirmar.",
    "common.loading": "Carregando…",
    "common.language": "Idioma",
    "common.firstName": "Nome",
    "common.lastName": "Sobrenome",
    "common.phone": "Celular",
    "common.email": "E-mail",
    "common.country": "País",
    "common.countryPlaceholder": "BR",
    "common.state": "Estado",
    "common.city": "Cidade",
    "common.actions": "Ações",
    "common.createdAt": "Criado em",
    "common.updatedAt": "Atualizado em",
    "common.none": "Nenhum",
    "common.yes": "Sim",
    "common.no": "Não",
    "common.saveError": "Erro ao salvar.",
    "common.loadError": "Erro ao carregar.",
    "common.deleteError": "Não foi possível excluir. Tente novamente.",
    "common.copy": "Copiar",
    "common.copied": "Copiado!",
    "common.done": "Concluir",
    "common.close": "Fechar",
    "common.retry": "Tentar novamente",

    "nav.dashboard": "Dashboard",
    "nav.events": "Eventos",
    "nav.championships": "Campeonatos",
    "nav.sports": "Modalidades",
    "nav.sportCategories": "Categorias",
    "nav.admin": "Admin",
    "nav.accounts": "Usuários",
    "nav.settings": "Configurações",
    "nav.logout": "Sair",
    "nav.backToSite": "Voltar ao site",

    "dashboard.title": "Dashboard",
    "dashboard.welcome": "Bem-vindo ao {brand}",
    "dashboard.subtitle": "Selecione uma opção no menu lateral para começar.",

    "login.title": "Entrar",
    "login.email": "E-mail",
    "login.password": "Senha",
    "login.continue": "Continuar",
    "login.office365": "Entrar com Office 365",
    "login.secface": "Entrar com SecFace",
    "login.sso": "Entrar com SSO",
    "login.contactHint": "Caso não lembre seu e-mail cadastrado entre em contato através do nosso e-mail",
    "login.mfaTitle": "Código de dois fatores",
    "login.wrongPassword": "Senha incorreta. Tente novamente.",
    "login.headline": "Acessar o sistema",
    "login.subtitle": "Entre com o e-mail cadastrado no sistema.",
    "login.emailPlaceholder": "voce@exemplo.com",
    "login.validateCode": "Validar código",
    "login.codeNotReceived": "Não recebeu o código?",
    "login.mfaSubtitle": "Informe o código de 6 dígitos do seu aplicativo autenticador.",
    "login.passwordPlaceholder": "Digite sua senha",
    "login.passwordSubtitle": "Informe a senha da sua conta para continuar.",
    "login.signIn": "Entrar",
    "login.changePassword": "Alterar senha",
    "login.changePasswordSubtitle": "Sua senha precisa ser alterada antes de continuar.",
    "login.newPassword": "Nova senha",
    "login.newPasswordPlaceholder": "Digite a nova senha",
    "login.confirmPassword": "Confirmar nova senha",
    "login.confirmPasswordPlaceholder": "Confirme a nova senha",
    "login.check.minLength": "Mínimo 8 caracteres",
    "login.check.uppercase": "Letra maiúscula",
    "login.check.lowercase": "Letra minúscula",
    "login.check.special": "Caractere especial",
    "login.check.match": "Senhas coincidem",
    "login.passwordMismatch": "As senhas não coincidem.",
    "login.changePasswordError": "Erro ao alterar a senha.",
    "login.invalidCode": "Código inválido. Tente novamente.",
    "login.or": "ou",
    "login.resend": "Reenviar",
    "login.incompleteCode": "Digite o código completo de 6 dígitos.",
    "login.adminOnlyTitle": "Área exclusiva de administradores",
    "login.adminOnlyHint":
      "Você não precisa de conta para ver nem baixar suas fotos — é só abrir o evento no site público.",
    "login.goToPublic": "Ir para o site de fotos",
    "login.configErrorTitle": "Serviço indisponível",
    "login.configErrorHint": "Não foi possível carregar a configuração de acesso. Tente novamente em instantes.",
    "login.configRetry": "Tentar novamente",
    "sso.finishing": "Concluindo login…",
    "sso.failed": "Falha no login",
    "sso.wait": "Aguarde, validando autenticação SSO.",
    "sso.backToLogin": "Voltar ao login",
    "sso.error": "Falha ao concluir o login SSO.",


    "account.title": "Usuários",
    "account.subtitle": "Gerencie os usuários e seus níveis de permissão.",
    "account.new": "Novo usuário",
    "account.edit": "Editar usuário",
    "account.newSubtitle": "O usuário recebe por e-mail a senha inicial e o QR Code do MFA.",
    "account.empty": "Nenhum usuário cadastrado.",
    "account.role": "Nível de permissão",
    "account.role.user": "Usuário",
    "account.role.operator": "Operador",
    "account.role.admin": "Administrador",
    "account.roleHint": "Menor privilégio: Operador cuida de eventos e fotos; Administrador também gerencia usuários e configurações.",
    "account.language": "Idioma",
    "account.languageDefault": "Padrão do sistema",
    "account.policyLabel": "Política de senha",
    "account.mustChange": "Exigir troca de senha no próximo acesso",
    "account.cannotChange": "Não permitir que este usuário troque a senha",
    "account.policyExclusive": "As duas opções são mutuamente exclusivas.",
    "account.mfaTitle": "Autenticação em duas etapas (MFA)",
    "account.mfaHint":
      "Escaneie o QR Code no app autenticador (Google Authenticator, Authy…) ou use o segredo manualmente.",
    "account.resetMfa": "Redefinir MFA",
    "account.resetMfaTitle": "Redefinir o MFA deste usuário?",
    "account.resetMfaBody":
      "Um novo segredo é gerado e o autenticador configurado anteriormente para de funcionar imediatamente.",
    "account.resetMfaDone": "MFA redefinido",
    "account.resetMfaDoneBody": "Envie o novo QR Code ao usuário para ele cadastrar novamente.",
    "account.resetMfaError": "Erro ao redefinir o MFA.",
    "account.deleteTitle": "Remover usuário?",
    "account.deleteBody": "Tem certeza que deseja remover {name}?",
    "account.registered": "Usuário cadastrado",
    "account.credentialsSent": "A senha e o QR Code do MFA foram enviados por e-mail ao usuário.",
    "account.initialPassword": "Senha inicial",
    "account.detailsTitle": "Detalhes do usuário",
    "account.notFound": "Usuário não encontrado.",
    "account.status": "Situação",
    "account.active": "Ativo",
    "account.inactive": "Inativo",

    "settings.title": "Configurações gerais",
    "settings.subtitle": "Configure os parâmetros gerais do sistema",
    "settings.save": "Salvar configurações",
    "settings.saving": "Salvando…",
    "settings.saved": "Configurações salvas com sucesso.",
    "settings.saveError": "Erro ao salvar configurações.",
    "policy.title": "Política de senha",
    "policy.subtitle": "Configure os requisitos mínimos de senha para todos os usuários",
    "policy.minLength": "Comprimento mínimo",
    "policy.minLengthHint": "Número mínimo de caracteres (8-40).",
    "policy.requireUppercase": "Exigir letra maiúscula",
    "policy.requireUppercaseHint": "A senha deve conter ao menos uma letra maiúscula (A-Z).",
    "policy.requireLowercase": "Exigir letra minúscula",
    "policy.requireLowercaseHint": "A senha deve conter ao menos uma letra minúscula (a-z).",
    "policy.requireSpecial": "Exigir caractere especial",
    "policy.requireSpecialHint": "A senha deve conter ao menos um caractere especial (!@#$%…).",
    "policy.blacklist": "Palavras bloqueadas",
    "policy.blacklistHint": "Palavras que não podem estar contidas na senha (case-insensitive).",
    "policy.blacklistEmpty": "Nenhuma palavra bloqueada.",
    "policy.add": "Adicionar",
    "policy.save": "Salvar política",
    "policy.saved": "Política de senha salva com sucesso.",
    "policy.saveError": "Erro ao salvar política de senha.",
    "policy.tabData": "Dados",
    "policy.tabPolicy": "Política de senha",

    // Campeonatos (painel)
    "championship.title": "Campeonatos",
    "championship.subtitle": "Competições que agrupam os eventos (as etapas).",
    "championship.new": "Novo campeonato",
    "championship.edit": "Editar campeonato",
    "championship.newSubtitle": "Preencha os dados para cadastrar um novo campeonato.",
    "championship.editSubtitle": "Altere os dados do campeonato.",
    "championship.empty": "Nenhum campeonato cadastrado.",
    "championship.notFound": "Campeonato não encontrado.",
    "championship.name": "Nome do campeonato",
    "championship.namePlaceholder": "Copa Verão",
    "championship.description": "Descrição",
    "championship.season": "Temporada",
    "championship.seasonPlaceholder": "2026",
    "championship.seasonHint": "A edição que diferencia um ano do outro (2026, 2025/26).",
    "championship.organizer": "Organizador",
    "championship.organizerPlaceholder": "Liga Sul",
    "championship.events": "Eventos",
    "championship.eventsCount": "{count} evento(s)",
    "championship.noEvents": "Nenhum evento vinculado a este campeonato ainda.",
    "championship.publicUrl": "Endereço público",
    "championship.searchPlaceholder": "Buscar pelo nome do campeonato",
    "championship.deleteTitle": "Excluir campeonato?",
    "championship.deleteBody": "Tem certeza que deseja excluir {name}? Os eventos são mantidos, apenas sem o campeonato.",

    "event.title": "Eventos",
    "event.subtitle": "Gerencie os eventos e seus acervos de fotos.",
    "event.new": "Novo evento",
    "event.edit": "Editar evento",
    "event.duplicate": "Duplicar",
    "event.duplicateTitle": "Duplicar evento",
    "event.duplicateSubtitle":
      "Dados copiados de “{name}”. Fotos e capa não são copiados — " +
      "escolha um novo nome e salve para criar o evento.",
    "event.newSubtitle": "Preencha os dados para cadastrar um novo evento.",
    "event.editSubtitle": "Altere os dados e configurações do evento.",
    "event.empty": "Nenhum evento cadastrado.",
    "event.notFound": "Evento não encontrado.",
    "event.name": "Nome do evento",
    "event.namePlaceholder": "Torneio Regional de Basquete",
    "event.description": "Descrição",
    "event.dates": "Datas",
    "event.startDate": "Data de início",
    "event.endDate": "Data de conclusão",
    "event.category": "Tipo de evento",
    "event.sport": "Modalidade",
    "event.sportPlaceholder": "Selecione a modalidade",
    "event.sportCategory": "Categoria",
    "event.noSportCategory": "Sem categoria",
    "event.sportCategoryHint": "O chip da categoria aparece no canto do card do evento no site público. As categorias são cadastradas no menu Categorias.",
    "sport.title": "Modalidades",
    "sport.subtitle": "Modalidades oferecidas no cadastro do evento.",
    "sport.new": "Nova modalidade",
    "sport.newSubtitle": "Inclua uma modalidade na lista.",
    "sport.edit": "Editar modalidade",
    "sport.editSubtitle": "Renomeie a modalidade. Os eventos que a usam passam a exibir o novo nome.",
    "sport.name": "Nome",
    "sport.namePlaceholder": "Ex.: Basquete",
    "sport.searchPlaceholder": "Buscar pelo nome da modalidade",
    "sport.empty": "Nenhuma modalidade cadastrada.",
    "sport.categories": "Categorias",
    "sport.events": "Eventos",
    "sport.viewCategories": "Categorias desta modalidade",
    "sport.deleteTitle": "Excluir modalidade?",
    "sport.deleteBody": "Excluir {name}? Os eventos que já a usam continuam exibindo-a, mas ela deixa de ser oferecida.",
    "sportCategory.title": "Categorias",
    "sportCategory.subtitle": "Categorias de cada modalidade e as cores do chip exibido no card do evento.",
    "sportCategory.new": "Nova categoria",
    "sportCategory.newSubtitle": "Crie uma categoria e escolha as cores do chip.",
    "sportCategory.edit": "Editar categoria",
    "sportCategory.editSubtitle": "Altere o nome ou as cores do chip.",
    "sportCategory.name": "Nome",
    "sportCategory.namePlaceholder": "Ex.: Sub-15 Masculino",
    "sportCategory.searchPlaceholder": "Buscar pelo nome da categoria",
    "sportCategory.allSports": "Todas as modalidades",
    "sportCategory.empty": "Nenhuma categoria cadastrada.",
    "sportCategory.chip": "Chip",
    "sportCategory.colors": "Cores do chip",
    "sportCategory.backgroundColor": "Cor de fundo",
    "sportCategory.textColor": "Cor do texto",
    "sportCategory.preview": "Prévia",
    "sportCategory.customColors": "Cores personalizadas — nenhum preset corresponde.",
    "sportCategory.deleteTitle": "Excluir categoria?",
    "sportCategory.deleteBody": "Excluir {name}? Os eventos que a usam deixam de exibir o chip.",
    "chipPreset.male": "Masculino",
    "chipPreset.female": "Feminino",
    "chipPreset.mixed": "Misto",
    "chipPreset.neutral": "Neutro",
    "chipPreset.youth": "Base",
    "chipPreset.adult": "Adulto",
    "chipPreset.master": "Master",
    "chipPreset.highlight": "Destaque",
    "chipPreset.maleStrong": "Masculino (forte)",
    "chipPreset.femaleStrong": "Feminino (forte)",
    "chipPreset.dark": "Escuro",
    "chipPreset.light": "Claro",
    "event.championship": "Campeonato",
    "event.noChampionship": "Sem campeonato (evento avulso)",
    "event.championshipHint": "Vincule o evento a uma competição para ele aparecer na página do campeonato.",
    "event.locationSection": "Local do evento",
    "event.locationName": "Local",
    "event.locationPlaceholder": "Ginásio Municipal",
    "event.address": "Endereço",
    "event.place": "Local",
    "event.photos": "Fotos",
    "event.pending": "Em processamento",
    "event.people": "Pessoas",
    "event.status": "Situação",
    "event.statusHint": "Publicado: aparece no site público. Não listado: fica fora das listagens e buscas, mas quem tem o link vê as fotos. Rascunho e Arquivado não são públicos.",
    "event.watermark": "Adicionar marca d'água",
    "event.features": "Recursos",
    "event.feature.watermark": "Fotos com marca d'água",
    "event.watermarkHint": "Todas as fotos do evento recebem a marca d'água do site no canto inferior direito. Alterar num evento que já tem fotos atualiza as existentes em segundo plano, aos poucos.",
    "event.allStatuses": "Todas as situações",
    "event.searchPlaceholder": "Buscar pelo nome do evento",
    "event.deleteTitle": "Excluir evento?",
    "event.deleteBody":
      "Tem certeza que deseja excluir {name}? As fotos deixam de ser publicadas.",
    "event.viewPublic": "Ver página pública",
    "event.coverTitle": "Capa do evento",
    "event.coverSubtitle": "A imagem que representa o evento no site público.",
    "event.coverUpload": "Enviar imagem",
    "event.coverRemove": "Remover capa",
    "event.coverHint":
      "Clique ou arraste uma imagem para cá. Sem capa definida, a primeira foto tratada é usada automaticamente. Você também pode escolher qualquer foto abaixo pelo botão de imagem.",
    "event.coverError": "Não foi possível alterar a capa.",
    "event.coverDropHere": "Solte a imagem aqui para usá-la como capa",
    "event.coverDropInvalid": "O arquivo solto não é uma imagem.",
    "event.coverRemoveTitle": "Remover a capa?",
    "event.coverRemoveBody":
      "O evento volta a usar a primeira foto tratada como capa.",
    "event.setAsCover": "Definir como capa",
    "event.pendingCount": "{count} na fila",
    "event.peopleEmpty": "Nenhum rosto agrupado ainda.",
    "event.personPhotos": "{count} fotos",
    "event.status.draft": "Rascunho",
    "event.status.published": "Publicado",
    "event.status.unlisted": "Não listado",
    "event.status.archived": "Arquivado",
    "event.tab.photos": "Fotos",
    "event.tab.people": "Pessoas",
    "event.category.sports": "Esporte",
    "event.category.corporate": "Corporativo",
    "event.category.party": "Festa",
    "event.category.wedding": "Casamento",
    "event.category.graduation": "Formatura",
    "event.category.concert": "Show",
    "event.category.other": "Outro",

    "photo.uploadTitle": "Enviar fotos",
    "photo.uploadSubtitle":
      "Os arquivos são enviados um a um. O tratamento (JPEG 1080p e detecção de rostos) acontece em segundo plano logo depois.",
    "photo.dropTitle": "Arraste as fotos aqui ou clique para escolher",
    "photo.dropHint": "JPEG, PNG, WEBP, HEIC ou TIFF de até 40 MB cada.",
    "photo.queueSummary": "{done} de {total} prontas",
    "photo.queueUploaded": "{count} de {total} enviadas",
    "photo.queueBusy": "{count} em andamento",
    "photo.clearFinished": "Limpar concluídas",
    "photo.facesFound": "{count} rostos",
    "photo.uploadError": "Falha no envio.",
    "photo.empty": "Nenhuma foto neste evento ainda.",
    "photo.clear": "Limpar fotos",
    "photo.clearTitle": "Excluir todas as fotos?",
    "photo.clearBody": "As {count} fotos deste evento serão excluídas definitivamente, junto com os rostos e as pessoas reconhecidas. Não é possível desfazer.",
    "photo.clearConfirm": "Excluir tudo",
    "photo.clearWord": "excluir",
    "photo.deleteTitle": "Excluir foto?",
    "photo.deleteBody":
      "O arquivo da foto e a biometria extraída dela são apagados definitivamente. Não é possível desfazer.",
    "photo.reprocess": "Processar novamente",
    "photo.reprocessError": "Não foi possível recolocar a foto na fila.",
    "photo.faceUnavailable": "Tratada sem reconhecimento facial.",
    "photo.status.queued": "Na fila",
    "photo.status.uploading": "Enviando",
    "photo.status.processing": "Processando",
    "photo.status.done": "Pronta",
    "photo.status.failed": "Falhou",
    "photo.replaced": "atualizada",
    "photo.merged": "o evento já tinha esta imagem — ficou a cópia mais completa",

    "public.nav.events": "Eventos",
    "public.nav.photoEditor": "Editor de fotos",
    "public.nav.signIn": "Entrar",
    "public.home.headline": "Encontre suas fotos do evento",
    "public.home.subtitle":
      "Navegue pelos eventos cobertos e use sua selfie para achar todas as fotos em que você aparece.",
    "public.home.searchPlaceholder": "Buscar por evento, local ou cidade",
    "public.home.allCategories": "Todos os tipos",
    "public.home.allCities": "Todas as cidades",
    "public.home.allChampionships": "Todos os campeonatos",
    "public.home.when": "Período",
    "public.home.when.all": "Qualquer data",
    "public.home.when.active": "Acontecendo agora",
    "public.home.when.upcoming": "Em breve",
    "public.home.when.past": "Encerrados",
    "public.home.eventsTitle": "Eventos",
    "public.home.empty": "Nenhum evento encontrado",
    "public.home.emptyHint": "Tente outro termo de busca ou limpe os filtros.",
    "public.home.loadErrorHint": "Não foi possível carregar os eventos. Tente novamente.",
    "public.championship.eventsTitle": "Eventos deste campeonato",
    "public.championship.eventsCount": "{count} evento(s)",
    "public.championship.empty": "Nenhum evento publicado ainda",
    "public.championship.notFoundHint": "Este campeonato não tem evento publicado, ou o endereço está errado.",
    "public.championship.backHome": "Voltar aos eventos",

    "public.event.photos": "fotos",
    "public.event.notFound": "Evento não encontrado",
    "public.event.backToEvents": "Voltar aos eventos",
    "public.event.allPhotos": "Todas as fotos",
    "public.event.noPhotos": "Nenhuma foto publicada ainda",
    "public.event.noPhotosHint": "As fotos aparecem aqui assim que forem tratadas.",
    "public.event.previous": "Anterior",
    "public.event.next": "Próxima",
    "public.event.loadingMore": "Carregando mais fotos…",
    "public.event.endOfAlbum": "Você chegou ao fim do álbum.",
    "public.search.title": "Encontre suas fotos",
    "public.search.hint":
      "Envie uma selfie e procuramos o seu rosto nas fotos deste evento. A selfie é usada apenas na comparação e não é armazenada.",
    "public.search.action": "Enviar selfie",
    "public.search.showAll": "Ver todas as fotos",
    "public.search.error": "Não foi possível fazer a busca. Tente novamente.",
    "public.search.resultsTitle": "Suas fotos",
    "public.search.noResults": "Nenhuma foto encontrada",
    "public.search.noResultsHint":
      "Tente outra selfie, de frente e com boa iluminação.",
    "public.search.copyLink": "Copiar link da busca",
    "public.search.sharedNotFound": "Esta busca não está mais disponível.",
    "public.search.openEvent": "Ver evento",
    "public.home.selfieTitle": "Encontre suas fotos em todos os eventos",
    "public.home.selfieHint":
      "Envie uma selfie e procuramos o seu rosto nas fotos dos eventos que atendem aos filtros acima. A selfie é usada apenas na comparação e não é armazenada.",
    "public.home.showEvents": "Ver eventos",
    "public.selfie.title": "Busque suas fotos com uma selfie",
    "public.selfie.drag": "Arraste uma imagem aqui ou",
    "public.selfie.upload": "envie um arquivo",
    "public.selfie.or": "ou",
    "public.selfie.paste": "Colar imagem",
    "public.selfie.pasteHint": "Você também pode pressionar Ctrl+V (⌘+V no Mac).",
    "public.selfie.searching": "Procurando o seu rosto nas fotos…",
    "public.selfie.notImage": "O arquivo selecionado não é uma imagem.",
    "public.selfie.clipboardEmpty": "Não há imagem na área de transferência.",
    "public.selfie.clipboardDenied":
      "Não foi possível ler a área de transferência. Pressione Ctrl+V (⌘+V no Mac) para colar a imagem.",
    "public.selfie.privacy":
      "A selfie é usada apenas na comparação e não é armazenada.",
    "public.photo.notFound": "Foto não encontrada",
    "public.photo.backToEvent": "Voltar ao evento",
    "public.photo.download": "Baixar",
    "public.photo.share": "Compartilhar",
    "public.footer.aboutTitle": "Feito por um pai, para o esporte. 🏀📸",
    "public.footer.aboutP1":
      "Sou pai de atleta e criei o Photoe por paixão pelo esporte e pela fotografia.",
    "public.footer.aboutP2":
      "Este projeto não possui fins lucrativos. Seu objetivo é registrar e compartilhar momentos dos jogos, campeonatos e eventos das equipes das quais meu filho fizer parte, independentemente do clube, escola ou time que ele esteja representando.",
    "public.footer.aboutP3":
      "As fotografias são uma forma de preservar histórias, valorizar os atletas e permitir que famílias, amigos e equipes guardem um pouco de cada momento vivido dentro e fora das quadras.",

    "error.accessDenied": "Acesso negado.",
    "error.generic": "Algo deu errado. Tente novamente.",
  },
};
